import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLanguage } from "@/context/LanguageContext";
import { indexLabels } from "@/i18n";

interface RegistrationInputButtonProps {
  onClick: () => void;
  className?: string;
}

export const RegistrationInputButton: React.FC<
  RegistrationInputButtonProps
> = ({ onClick, className = "" }) => {
  const isMobile = useIsMobile();
  const { language } = useLanguage();
  const labels = indexLabels(language);

  return (
    <div className={`text-center ${className}`}>
      <div className="space-y-4 max-w-md mx-auto px-4">
        <div className="flex flex-col items-center space-y-2">
          <label className="text-xs sm:text-sm text-white/90">
            {labels.valuation.registrationNumber}
          </label>
          <div className="flex items-center justify-center gap-2 w-full">
            <div className="relative w-full max-w-[380px]">
              <div className="absolute left-0 top-0 bottom-0 pt-1 w-[50px] sm:w-[60px] bg-[#003399] rounded-l-md z-10">
                <div className="w-full h-full flex items-center justify-center relative">
                  <div className="text-white text-xs font-bold">SE</div>
                </div>
              </div>
              <div
                onClick={onClick}
                className={`pl-[60px] sm:pl-[70px] flex items-center justify-center uppercase tracking-[0.1em] sm:tracking-[0.2em] h-[50px] sm:h-[60px] w-full bg-white font-bold border-[2px] sm:border-[3px] border-[#0E1116] rounded-md text-[#4A5568] cursor-pointer hover:bg-gray-50 transition-colors font-mono ${
                  isMobile ? "text-xl sm:text-2xl" : "text-[2.5rem]"
                }`}
                style={{ fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace' }}
              >
                ABC 123
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
